import { MutationTree } from 'vuex';
import {
  FETCH_DEVICE_COUNT,
  FETCH_FILTER_PERSONALISATIONS,
  FETCH_PERSONALISATION_DETAILS,
  FETCH_INSTANCENAMES_BY_DEVICE_ID,
  SET_ERROR,
  UPDATE_PERSONALISATIONS_LIST_STATE,
  UPDATE_NAVIGATION,
  PERSO_NAVIGATION,
  IPersonalisationStatePayload,
  PersonalisationState,
  REINIT
} from './types';

const mutations: MutationTree<PersonalisationState> = {
  [REINIT](state: PersonalisationState) {
    state.navigation.filters = {};
    state.navigation.start = 0;
  },
  [FETCH_DEVICE_COUNT](state: PersonalisationState, payload) {
    state.deviceCount = payload;
  },
  [PERSO_NAVIGATION](state: PersonalisationState, { direction }) {
    const incrementValues: any = {
      forward: state.navigation.size,
      backward: state.navigation.size * -1
    };
    state.navigation.start += incrementValues[direction];
  },
  [FETCH_FILTER_PERSONALISATIONS](state: PersonalisationState, payload) {
    state.personalisations = payload.personalisations;
    state.totalSize = payload.total;
  },
  [FETCH_PERSONALISATION_DETAILS](state: PersonalisationState, payload) {
    state.personalisationDetails[payload.id] = payload.details;
  },
  [FETCH_INSTANCENAMES_BY_DEVICE_ID](state: PersonalisationState, payload) {
    const { deviceID } = payload;
    state.instanceNames.push({ id: deviceID, instances: payload.instanceNames });
  },
  [SET_ERROR](state: PersonalisationState, payload) {
    state.errorMessage = payload;
  },
  [UPDATE_NAVIGATION](state: PersonalisationState, payload) {
    state.navigation = payload;
  },
  [UPDATE_PERSONALISATIONS_LIST_STATE](state: PersonalisationState, payload: IPersonalisationStatePayload) {
    const {
      view,
      stateKey,
      stateValue
    } = payload;
    state.personalisationState[stateKey][view] = stateValue;
  }
};

export default mutations;
